// extracted by mini-css-extract-plugin
export default {"main_wrapper":"ResultDashbor_main_wrapper__vvbkR","sideBarToogle":"ResultDashbor_sideBarToogle__G6pZI"};